/**
 * Helpers for No Client Action Required (Control Panel actionType=no_action)
 * vs No Report Required (workspace status). Keep these concepts separate.
 */

export const NO_ACTION_REQUIRED_MARKER = 'No Action Required';

/** True when the report was completed via the No Client Action Required Filed Notes path. */
export function isNoClientActionRequiredComplete(
  additionalNotes: string | null | undefined,
  status?: string | null | undefined,
): boolean {
  const notes = String(additionalNotes ?? '').trim();
  if (notes !== NO_ACTION_REQUIRED_MARKER) return false;
  if (status == null || String(status).trim() === '') return true;
  return String(status).trim() === 'Filed';
}

/** Preview dialog title for NCA vs notice File Now. */
export function getStateReportPreviewTitle(
  additionalNotes: string | null | undefined,
  status?: string | null | undefined,
): string {
  if (isNoClientActionRequiredComplete(additionalNotes, status)) {
    return 'Report Completed On Your Behalf';
  }
  return 'Notice of State Report';
}

/**
 * Client-facing Additional Notes: hide the internal workflow marker.
 * Prefer notesToClient (Control Panel Additional_Notes) when present.
 */
export function getClientFacingAdditionalNotes(
  additionalNotes: string | null | undefined,
  notesToClient?: string | null | undefined,
): string {
  const marker = String(additionalNotes ?? '').trim();
  const clientNotes = String(notesToClient ?? '').trim();
  if (marker === NO_ACTION_REQUIRED_MARKER) {
    return clientNotes;
  }
  return marker;
}

/** Whether Filed Notes should show the attachment picker (NCA layout only, never NRR). */
export function shouldShowFiledNotesAttachments(
  openFiledNotes: boolean,
  targetStatus: string | null | undefined,
): boolean {
  if (!openFiledNotes) return false;
  return String(targetStatus ?? '').trim() !== 'No Report Required';
}
